import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const rootSx: SvgIconProps['sx'] = {
  color: 'inherit',
  '& path': { fill: 'currentColor', color: 'inherit' },
}

export const DynamicFeedRoundedIcon: React.FC<SvgIconProps> = ({ sx, ...props }) => (
    <SvgIcon
        viewBox="0 0 24 24"
        sx={[rootSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
        {...props}
    >
        <path
            d="M7 8c-.55 0-1 .45-1 1v6c0 1.1.9 2 2 2h8c.55 0 1-.45 1-1s-.45-1-1-1H8V9c0-.55-.45-1-1-1"
            stroke="none"
            fill="currentColor"
        />
        <path
            d="M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 8h-8V7h8zM3 12c-.55 0-1 .45-1 1v6c0 1.1.9 2 2 2h8c.55 0 1-.45 1-1s-.45-1-1-1H4v-6c0-.55-.45-1-1-1"
            stroke="none"
            fill="currentColor"
        />
    </SvgIcon>
)
